import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';

export default class BindMobileService extends CommonService {
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCode = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCode({
      ...rest,
      type: 8,
      ...extra_params,
    });
  };

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCodeV2({
      ...rest,
      type: 8,
      ...extra_params,
    });
  };
  /**
   * [bind mobile]
   * @param {string} mobile mobile number
   * @param {string} code verify code
   * @param {number} unbind_exist
   */
  public mobileBind = (params: {
    mobile: string;
    code: string;
    unbind_exist?: number;
    extra_params?: object;
  }): Promise<any> => {
    let { mobile, code, extra_params = {}, ...rest } = params;
    const data = encryptParams(
      { mobile, code, ...rest, type: 8, ...extra_params },
      ['mobile', 'type', 'code']
    );
    return this.request({
      url: WEB_SSO.BIND_MOBILE,
      method: 'POST',
      data,
    });
  };
}
